// app/lib/api/types/index.ts

export enum CroppingTemplate {
  FULLSCREEN = "fullscreen",
  CROPPED = "cropped",
  STACKED = "stacked"
}

export interface HighlightConfig {
  template: CroppingTemplate;
  text_color: string;
  censor_subtitles: boolean;
  facecam_coordinates: [number | null, number | null, number | null, number | null];
  gameplay_bounds: [number | null, number | null, number | null, number | null];
  font_name: string;
  text_height: number | null;
  outline_thickness: number | null;
  outline_color: string | null;
  words_per_line: number | null;
  font_size: number | null;
  subtitles_enabled: boolean;
}
  
export interface HighlightCard {
  highlight_id: string| null;
  highlight_url: string;
  highlight_start_time: string | null;
  highlight_end_time: string | null;
  highlight_title: string;
  highlight_label: string;
  highlight_description: string;
  highlight_score: number | null;
  liked: boolean | null;
}

export interface StreamInfo {
  stream_id: string;
  stream_url: string;
  highlights: string[];
  created_at: string;
  thumbnail_url: string;
  stream_name: string;
  num_highlights: number;
}

export interface LivestreamInfo {
  livestream_id: string;
  created_at: string;
  thumbnail_url?: string;  // Optional fields use '?' in TypeScript
  livestream_title?: string;
}

export interface GetRecentLivestreamsResponse {
  items: LivestreamInfo[];
  next_cursor?: string;
}

export interface HighlightRequest {
  url: string;
  HighlightConfig: HighlightConfig;
}

export interface LikedUpdate {
  highlight_id: string;
  liked: boolean;
}

export interface CopyLinkUpdate {
  highlight_id: string;
}

export interface DownloadUpdate {
  highlight_id: string;
}

export interface HighlightMetadataUpdate {
  highlight_id: string;
  title: string;
  description: string;
}

export interface DownloadLinkRequest {
  highlight_id: string;
  page: string;
}

export interface AutomationResponse {
  twitch_usernames: string[];
  count: number;
}

export interface RecentClipsRequest {
  items: HighlightCard[];
  next_cursor: string;
}

export interface PresetBase {
  template: CroppingTemplate;
  font: string;
  text_color: string;
  censor_subtitles: boolean;
  subtitles_enabled: boolean;
  words_per_line: number;
}

export interface PresetCreate extends PresetBase {
  //no preset_id needed for creation
}

export interface PresetUpdate extends Partial<PresetBase> {
  preset_id: string;
}

export interface PresetResponse extends PresetBase {
  preset_id: string;
}

export interface BotStatusResponse {
  message: string;
  activated: boolean;
}

export interface Testimonial {
  id: string;
  name: string;
  company: string;
  quote: string;
  avatar: string;
  gradient?: string;
} 

export interface SubscriptionInfo {
  subscription_tier: SubscriptionTier;
  free_credits_remaining: number;
}

export enum SubscriptionTier {
  FREE = "free",
  STARTER = "starter",
  PRO = "pro",
  PRO_LEGACY_411 = "pro_legacy_411"
}

export enum BillingCycle {
  MONTHLY = "monthly",
  ANNUAL = "annual"
}

export interface CheckoutRequest {
  tier: SubscriptionTier;
  billing_cycle: BillingCycle;
  referral: string | null;
}

export interface SubmissionRequestBody {
  bounty_id: string;
  video_url: string;
}

export interface SubmissionResponse {
  submission_id: string;
  video_url: string;
  views: number;
  view_check: boolean;
  payment_amount: number;
}

export interface BountyDetail {
  bounty_id: string;
  name: string;
  cpm: number;
  total_budget: number;
  budget_used: number;
  description: string;
  offer_copy: string | null;
  offer_link: string | null;
  image_url: string | null;
}